/**
 * EnergyConnect.WebApi | v1
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const UserResponse = {
    NotSpecified: 'NotSpecified',
    NotRequired: 'NotRequired',
    Required: 'Required',
    Approved: 'Approved',
    Rejected: 'Rejected',
    Cancelled: 'Cancelled',
    ManuallyHandled: 'ManuallyHandled',
} as const;
export type UserResponse = typeof UserResponse[keyof typeof UserResponse];

